import { Stack } from "@mui/system";

export const HStack = ({ children, ...props }) => {
  return (
    <Stack direction="row" {...props}>
      {children}
    </Stack>
  );
};
